<div class="chip d-flex align-items-center gap-4 p-4" [class.disabled]="disabled" (click)="selectedChanged()">
    <i-tabler style="margin: auto;" *ngIf="chip.selected"
              name="check"
              class="icon-14 d-flex m-r-4"
    ></i-tabler>
    <div>
        {{chip.label}}
    </div>
</div>
